import React from 'react';

import validate from '@vlabs/shared/validators';
import {
  Control, Margin, Grid, GridRow, GridCol,
} from '@vlabs/uikit';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import st from './CreateHandlerForm.module.sass';

interface SaveUniqueFormProps {
  listOptions?: {
    label: string;
    value: string;
  }[];
  onSubmit: (values: unknown) => void;
}

function SaveUniqueForm({
  listOptions = [],
  onSubmit,
}: SaveUniqueFormProps): React.JSX.Element {
  const { t } = useTranslation();
  const {
    register, control, handleSubmit, formState: { errors },
  } = useForm();

  return (
    <form
      data-testid="modal.saveUnique"
      onSubmit={handleSubmit(onSubmit)}
    >
      <Grid>
        <GridRow>
          <GridCol>
            <Margin display="block">
              <span className={st.Description}>
                {t('handlers:сценарий "Сохранение событий только для уникальных лиц для последующего подсчета" позволяет обнаружить все лица на кадре, сравнить обнаруженные лица со всеми лицами в списке уникальных лиц и, в случае если это лицо в списке отсутствует, сохранить лицо в этот список уникальных лиц.')}
              </span>
            </Margin>
            <Margin display="block">
              <div className="Body-2">{t('handlers:форма.наименование сценария')}</div>
              <Control.Input
                {...register('description', {
                  maxLength: validate.maxLength(128),
                  required: validate.required(),
                })}
                errors={errors}
              />
            </Margin>
            <Margin display="block">
              <div className="Body-2">{t('handlers:список уникальных лиц')}</div>
              <Control.Select
                control={control}
                errors={errors}
                id="listId"
                name="listId"
                options={listOptions}
                rules={{ required: validate.required() }}
              />
            </Margin>
          </GridCol>
        </GridRow>
      </Grid>
      <Margin display="block">
        <Control.Button
          fullWidth
          type="submit"
        >
          {t('handlers:создать')}
        </Control.Button>
      </Margin>
    </form>
  );
}

export default SaveUniqueForm;
